import "./index.css"

import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';

const Skeleton = forwardRef(({ className, height, width }, ref) => (jsx("div", { ref: ref, style: { height, width }, "data-testid": "skeleton-block", className: classNames('cds-skeleton', className) })));

export { Skeleton };
